import axios from 'axios';
import { Unit } from '../models/Unit';

export async function fetchUnit(unitHref: string) {
  const unit = await axios.get<Unit>(unitHref);
  return unit.data;
}
